import { Component } from '@angular/core';

@Component({
  selector: 'app-bank-payment-view',
  standalone: false,
  templateUrl: './bank-payment-view.component.html',
  styleUrl: './bank-payment-view.component.scss'
})
export class BankPaymentViewComponent {

}
